export enum QualityGateStatus {
  TODO = 'TODO',
  INPROGRESS = 'IN PROGRESS',
  PASS = 'PASS',
  FAIL = 'FAIL',
}
